import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { assets } from '../../config/assets'

export default function AboutUsSection() {
  const { t } = useTranslation()

  return (
    <div className="max-w-6xl mx-auto w-full px-4">
      <div className="bg-brand-cream/95 rounded-[2rem] md:rounded-[3rem] p-6 md:p-12 lg:p-16 shadow-2xl space-y-8 md:space-y-12">
        {/* Heading */}
        <h2 className="font-climate text-brand-blue text-3xl md:text-5xl lg:text-6xl text-center leading-tight">
          {t('home.aboutUs.title')}
        </h2>

        {/* Intro */}
        <p className="text-brand-blue/90 text-base md:text-lg leading-relaxed text-center max-w-4xl mx-auto">
          {t('home.aboutUs.intro')}
        </p>

        <p className="text-brand-blue/90 text-base md:text-lg leading-relaxed text-center max-w-4xl mx-auto">
          {t('home.aboutUs.story')}
        </p>

        {/* Parallel Worlds + image */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="space-y-4 md:space-y-6 order-2 md:order-1">
            <h3 className="font-climate text-brand-orange text-3xl md:text-5xl lg:text-6xl leading-tight">
              {t('home.aboutUs.brandName')}
            </h3>
            <p className="text-brand-blue/90 text-base md:text-lg leading-relaxed">
              {t('home.aboutUs.brandText')}
            </p>
          </div>
          <div className="order-1 md:order-2">
            <img
              src={assets.aboutUs.bookseller}
              alt={t('home.aboutUs.imageAlt')}
              className="w-full h-auto rounded-[2rem] shadow-xl object-cover"
            />
          </div>
        </div>

        {/* Subscription types */}
        <div className="space-y-6 md:space-y-8">
          <h3 className="font-climate text-brand-blue text-2xl md:text-4xl lg:text-5xl text-center">
            {t('home.aboutUs.subscriptionTypesTitle')}
          </h3>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            <p className="text-brand-blue/90 text-base md:text-lg leading-relaxed">
              {t('home.aboutUs.subscriptionTypesLeft')}
            </p>
            <p className="text-brand-blue/90 text-base md:text-lg leading-relaxed">
              {t('home.aboutUs.subscriptionTypesRight')}
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
            <Link
              to="/subscription/personal"
              className="block rounded-[2rem] overflow-hidden shadow-lg hover:shadow-xl hover:scale-[1.02] transition"
            >
              <img
                src={assets.aboutUs.individualCard}
                alt={t('home.aboutUs.individualCardAlt')}
                className="w-full h-auto"
              />
            </Link>
            <Link
              to="/subscriptions/thematic"
              className="block rounded-[2rem] overflow-hidden shadow-lg hover:shadow-xl hover:scale-[1.02] transition"
            >
              <img
                src={assets.aboutUs.thematicCard}
                alt={t('home.aboutUs.thematicCardAlt')}
                className="w-full h-auto"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
